import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  DtpContentContainer,
} from 'dtp-react-components';
import {
  Button,
} from '../../../components/index';
import {
  trataMensagensErro,
  trataMensagemSucesso,
  doPut,
  doGet,
  validateObject,
  requestMotivosCessacaoRequerimentoPensao,
  requestMotivosCessacaoRequerimentoAposentadoria,
} from '../../../utils/requests';
import {
  pensaoSemDependentesAtivos,
  getObject,
} from '../../../utils/listsSelect';
import DadosCessacaoAposentadoria from './DadosCessacaoAposentadoria';
import DadosCessacaoPensao from './DadosCessacaoPensao';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';
import ModalAlerta from '../../requerimentos/ModalAlerta';
import { msgsConfirmacaoCessacao } from '../../../utils/constants';

class RequerimentoCessacao extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }
  getInitialState = () => ({
    requerimento: {
      numeroBeneficio: null,
      matricula: null,
      nome: null,
      dataCessacaoBeneficio: null,
      descricaoMotivoCessacao: null,
      dataInicioBeneficio: null,
      motivoCessacao: null,
      fonteCessacao: null,
      dependentes: [],
      tipoRequerimento: null,
    },
    touched: false,
    listaMotivosCessacao: [],
    listaDependentesCessando: [],
    listaMotivosPensaoInativa: [{ value: 22, label: 'Pensão sem dependentes ativos' }],
    validadeCampos: {
      motivoCessacao: false,
      dataCessacaoBeneficio: false,
      descricaoMotivoCessacao: false,
    },
    acao: 'cessar-requerimento',
    estadoFormulario: 'inicial',
    showNoContent: false,
    noContentPrimaryMessage: 'Requerimento não encontrado para o protocolo informado.',
    noContentSecondaryMessage: 'Informe um protocolo válido.',
    requestPesquisa: null,
    showModalAlerta: false,
    chaveConfirmacao: null,
  });

  componentDidMount() {
    this.montaFormulario();
  }

  montaListaMotivosDisponiveis = () => {
    let listaMotivos = [];
    this.props.motivosCessacaoRequerimentoAposentadoria.forEach((motivo) => {
      if (this.state.requerimento.tipoAposentadoria !== 3) {
        if (motivo.value !== 24) {
          listaMotivos.push({
            value: motivo.value,
            label: motivo.label,
          });
        }
      } else {
        listaMotivos = this.props.motivosCessacaoRequerimento;
      }
    });
    this.setState({
      listaMotivosCessacao: listaMotivos,
    });
  }

  handleErrorBusca = () => {
    const mensagemPrimaria = 'Não foi possível consultar o motivo da cessação da aposentadoria.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
      mostraPaginaSemConteudo: true,
      mensagemPrincipalSemConteudo: mensagemPrimaria,
      mensagemSecundariaSemConteudo: mensagemSecundaria,
    });
  }

  buscaMotivosCessacaoRequerimentoAposentadoria = (tipo, tipoMotivo, tipoBeneficio) => {
    requestMotivosCessacaoRequerimentoAposentadoria(
      this.handleErrorBusca,
      tipo,
      tipoMotivo,
      tipoBeneficio,
    );
  }

  buscaMotivosCessacaoRequerimentoPensao = (tipo, tipoMotivo) => {
    requestMotivosCessacaoRequerimentoPensao(this.handleErrorBusca, tipo, tipoMotivo);
  }

  montaFormulario = () => {
    const paramAcao = this.props.match.params.acao;
    this.setState({
      paramAcao,
    }, this.buscaRequerimento);
  }

  handleSuccessBuscaRequerimento = (response) => {
    // 3 é o TE_MOTIVO_REQUERIMENTO da tabela MOTIVOS_REQUERIMENTO
    // que equivale ao tipo do motivo (tipoMotivo)
    const tipoMotivo = 3;
    const aplicacao = Number(this.props.match.params.tipoRequerimento);
    this.setState({
      requerimento: { ...this.state.requerimento, ...response.data },
    });
    const paramTipoBeneficio = this.state.requerimento.tipoBeneficio;
    const { validadeCampos } = { ...this.state };
    if (this.state.requerimento.dataCessacaoBeneficio) {
      validadeCampos.dataCessacaoBeneficio = true;
    }
    if (Number(this.props.match.params.tipoRequerimento) === 1) {
      this.setState(this.buscaMotivosCessacaoRequerimentoAposentadoria(
        aplicacao,
        tipoMotivo,
        paramTipoBeneficio,
      ));
      this.montaListaMotivosDisponiveis();
    } else {
      this.setState(this.buscaMotivosCessacaoRequerimentoPensao(aplicacao, tipoMotivo));
    }
  }

  buscaRequerimento = (metodoSucesso = this.handleSuccessBuscaRequerimento) => {
    let tipo = 'pensao';
    if (Number(this.props.match.params.tipoRequerimento) === 1) {
      tipo = 'aposentadoria';
    }
    const url = `requerimentos-cessacao-${tipo}/${this.props.match.params.protocolo}`;
    doGet(url, metodoSucesso, this.handleErrorBuscaRequerimento);
  }

  handleErrorBuscaRequerimento = (error) => {
    let mensagemPrimaria = 'Não foi possível consultar o requerimento.';
    let mensagemSecundaria = 'Contate o administrador do sistema.';
    if (error) {
      if (error.status) {
        if (error.status === 404) {
          mensagemPrimaria = 'Requerimento não encontrado para o protocolo informado.';
          mensagemSecundaria = 'Informe um protocolo válido.';
        }
      }
    }
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  trataSucessoResponsePesquisa = (response) => {
    this.setState({
      requerimento: {
        ...response.data,
      },
      requestPesquisa: null,
    });
  }

   verificaNumDepACessar = (dependentes) => {
     let contador = 0;
     if (dependentes) {
       dependentes.forEach((dependente) => {
         if (dependente.cessando) {
           contador += 1;
         }
       });
     }
     return contador;
   }

   verificaUltimo = (dependentes) => {
     let contador = 0;
     if (dependentes) {
       dependentes.forEach((dependente) => {
         if (dependente.cessando || dependente.foiCessado) {
           contador += 1;
         }
       });
     }
     return contador;
   }

  addSemDepAtivosLabel = (motivo) => {
    const obj = getObject(pensaoSemDependentesAtivos, motivo);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
  }

  formularioProntoParaEnvio = (tipoRequerimento) => {
    if (Number(tipoRequerimento) === 2) {
      const { requerimento } = { ...this.state };
      const numeroDependentesCessando = this.verificaNumDepACessar(requerimento.dependentes);
      if (numeroDependentesCessando === 0) {
        this.state.validadeCampos.dependentes = true;
      } else if (requerimento.dataCessacaoBeneficio === null &&
        requerimento.motivoCessacao === null) {
        this.state.validadeCampos.motivoCessacao = true;
        this.state.validadeCampos.dataCessacaoBeneficio = true;
        this.state.validadeCampos.descricaoMotivoCessacao = true;
      } else if (requerimento.dataCessacaoBeneficio === '' &&
        requerimento.motivoCessacao === '') {
        this.state.validadeCampos.motivoCessacao = true;
        this.state.validadeCampos.dataCessacaoBeneficio = true;
        this.state.validadeCampos.descricaoMotivoCessacao = true;
      }
      if (requerimento.motivoCessacao === 22) {
        this.state.validadeCampos.descricaoMotivoCessacao = true;
      }
    } else {
      this.state.validadeCampos.dependentes = true;
    }
    return validateObject(this.state.validadeCampos);
  }

  handleChangeDependentes = (changeObj, name) => {
    const { requerimento } = { ...this.state };
    let touched = true;
    let totalDependentesACessar =
    this.verificaNumDepACessar(requerimento.dependentes);
    // pesquisar na lista a maior ordem e pegar a data de cessacao do dependente
    let ordem = 0;
    if (changeObj.listaDependentesCessando) {
      changeObj.listaDependentesCessando.forEach((dependente) => {
        if (dependente.ordemCessacao) {
          ordem = dependente.ordemCessacao;
        }
        if (ordem < dependente.ordemCessacao) {
          ordem = dependente.ordemCessacao;
        }
      });
    }
    const indexDep =
    changeObj.listaDependentesCessando.findIndex(dep => (dep.ordemCessacao === ordem));
    if (indexDep === -1) {
      totalDependentesACessar = null;
    }

    if (totalDependentesACessar === requerimento.dependentes.length) {
      this.state.validadeCampos.dataCessacaoBeneficio = true;
      this.state.validadeCampos.motivoCessacao = true;
      requerimento.motivoCessacao = 22;

      let maiorDataCessacao = null;
      let maiorDataCessacaoString = null;
      requerimento.dependentes.forEach((dependente) => {
        if (maiorDataCessacao != null && dependente.dataCessacao != null) {
          const dataCessacaoDependente = moment(dependente.dataCessacao, 'DD/MM/YYYY').toDate();
          if (dataCessacaoDependente > maiorDataCessacao) {
            maiorDataCessacao = moment(dependente.dataCessacao, 'DD/MM/YYYY').toDate();
            maiorDataCessacaoString = dependente.dataCessacao;
          }
        } else {
          maiorDataCessacao = moment(dependente.dataCessacao, 'DD/MM/YYYY').toDate();
          maiorDataCessacaoString = dependente.dataCessacao;
        }
      });
      // requerimento.dataCessacaoBeneficio =
      // changeObj.listaDependentesCessando[indexDep].dataCessacao;
      requerimento.dataCessacaoBeneficio = maiorDataCessacaoString;
      totalDependentesACessar = 0;
    }
    if (requerimento.dependentes.length !== totalDependentesACessar) {
      if (requerimento.dependentes[indexDep].cessando === false) {
        requerimento.motivoCessacao = null;
        requerimento.dataCessacaoBeneficio = null;
        totalDependentesACessar = undefined;
        touched = false;
        const depPesquisa = requerimento.dependentes[indexDep].nome;
        const indexDepCancelado =
        changeObj.listaDependentesCessando.findIndex(pesquisa => (pesquisa.nome === depPesquisa));
        if (indexDepCancelado !== -1) {
          if (changeObj.listaDependentesCessando[indexDepCancelado].cessando === false) {
            changeObj.listaDependentesCessando.splice(indexDepCancelado, 1);
          }
        }
      } else {
        // verificar se tem mais alguem cessando ou cessado
        const ultimo = this.verificaUltimo(requerimento.dependentes);
        if (requerimento.dependentes.length === ultimo) {
          this.state.validadeCampos.dataCessacaoBeneficio = true;
          this.state.validadeCampos.motivoCessacao = true;
          requerimento.motivoCessacao = 22;

          let maiorDataCessacao1 = null;
          let maiorDataCessacaoString1 = null;
          requerimento.dependentes.forEach((dependente) => {
            if (maiorDataCessacao1 != null && dependente.dataCessacao != null) {
              const dataCessacaoDependente1 = moment(dependente.dataCessacao, 'DD/MM/YYYY').toDate();
              if (dataCessacaoDependente1 > maiorDataCessacao1) {
                maiorDataCessacao1 = moment(dependente.dataCessacao, 'DD/MM/YYYY').toDate();
                maiorDataCessacaoString1 = dependente.dataCessacao;
              }
            } else {
              maiorDataCessacao1 = moment(dependente.dataCessacao, 'DD/MM/YYYY').toDate();
              maiorDataCessacaoString1 = dependente.dataCessacao;
            }
          });
          // requerimento.dataCessacaoBeneficio =
          // changeObj.listaDependentesCessando[indexDep].dataCessacao;
          requerimento.dataCessacaoBeneficio = maiorDataCessacaoString1;
          totalDependentesACessar = 0;
        }
      }
    }

    this.setState({
      touched,
      requerimento: {
        ...requerimento,
        [name]: changeObj.value,
      },
      totalDependentesACessar,
      listaDependentesCessando: changeObj.listaDependentesCessando,
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
    });
  }

  handleChange = (changeObj, name, callback = null) => {
    // const { acao } = { ...this.state };
    let { estadoFormulario } = { ...this.state };
    const { requerimento } = { ...this.state };

    if (name === 'dataCessacaoBeneficio') {
      if (this.state.dataCessacaoBeneficio && this.state.validadeCampos.dependentes === false) {
        estadoFormulario = 'cessacao-requerimento';
      }
    }

    if (name === 'motivoCessacao') {
      const descricao = this.state.descricaoMotivoCessacao;
      if ((changeObj.value === 33 || changeObj.value === 34
        || changeObj.value === 35 || changeObj.value === 36)
        && descricao === undefined) {
        this.state.validadeCampos.descricaoMotivoCessacao = false;
      } else {
        this.state.validadeCampos.descricaoMotivoCessacao = true;
      }
    }

    this.setState({
      requerimento: {
        ...requerimento,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
      estadoFormulario,
    }, callback);
  }

  diffRequerimento = (tipoRequerimento) => {
    if (tipoRequerimento === 2) {
      return 'pensao';
    }
    return 'aposentadoria';
  }

  handleSaveButton = () => {
    const { requerimento } = { ...this.state };
    const tipo = Number(this.props.match.params.tipoRequerimento);
    let mensagemConfirmacao = '';
    if (tipo === 1) {
      mensagemConfirmacao = msgsConfirmacaoCessacao.cessacaoAposentadoria;
      this.setState({
        alertas: [mensagemConfirmacao],
        showModalAlerta: !this.state.showModalAlerta,
      });
    } else {
      const numeroDependentesCessando = this.verificaNumDepACessar(requerimento.dependentes);

      let todosDependentesCessados = false;
      let estaCessandoDependente = false;

      if (numeroDependentesCessando === requerimento.dependentes.length) {
        todosDependentesCessados = true;
      } else if (numeroDependentesCessando !== 0) {
        estaCessandoDependente = true;
        // ver quem esta cessando
      }
      // Quando cessa todos os dependentes, cessa o requerimento.
      if (todosDependentesCessados) {
        mensagemConfirmacao = msgsConfirmacaoCessacao.cessacaoPensao;
      } else if (estaCessandoDependente) {
        mensagemConfirmacao = msgsConfirmacaoCessacao.cessacaoDependente;

        if ((requerimento.dataCessacaoBeneficio !== null && requerimento.dataCessacaoBeneficio !== '') &&
        (requerimento.motivoCessacao !== null && requerimento.motivoCessacao !== '')) {
          mensagemConfirmacao = msgsConfirmacaoCessacao.cessacaoAmbos;
        }
      } else {
        mensagemConfirmacao = msgsConfirmacaoCessacao.cessacaoPensao;
      }
      this.setState({
        alertas: [mensagemConfirmacao],
        showModalAlerta: !this.state.showModalAlerta,
      });
    }
  }

  /**
   * Trata envio dos dados
   */
  confirmSendDataAposentadoria = () => {
    const touched = true;
    const url = 'requerimentos-cessacao';
    const { validadeCampos } = { ...this.state };
    const { requerimento } = { ...this.state };

    /* Valida se o campo fonteCessacao esta nulo ou vazio */
    if (requerimento.fonteCessacao === null ||
        requerimento.fonteCessacao === '') {
      requerimento.fonteCessacao = 0;
    }
    /* Valida se o campo fonteCessacao esta nulo ou vazio */
    if (requerimento.motivoCessacao === null ||
      requerimento.motivoCessacao === '') {
      requerimento.motivoCessacao = 0;
    }

    Object.keys(validadeCampos).forEach((key) => {
      validadeCampos[key] = true;
    });
    this.setState({
      touched,
      validadeCampos,
      requerimento,
    }, () => this.handleSave(url, 1));
  }

  confirmSendDataPensao = () => {
    const touched = true;
    const url = 'requerimentos-cessacao';
    const { validadeCampos } = { ...this.state };
    const { requerimento } = { ...this.state };

    /* Valida se o campo fonteCessacao esta nulo ou vazio */
    if (requerimento.fonteCessacao === null ||
        requerimento.fonteCessacao === '') {
      requerimento.fonteCessacao = 0;
    }
    /* Valida se o campo fonteCessacao esta nulo ou vazio */
    if (requerimento.motivoCessacao === null ||
      requerimento.motivoCessacao === '') {
      requerimento.motivoCessacao = 0;
    }

    Object.keys(validadeCampos).forEach((key) => {
      validadeCampos[key] = true;
    });

    this.setState({
      touched,
      validadeCampos,
      requerimento: {
        ...requerimento,
      },
    }, () => this.handleSave(url, 2));
  }

  /**
   * Trata as acoes dos botao Salvar "Criar Valor medio Beneficio"
   */
  handleSave = (url, tipo) => {
    if (this.formularioProntoParaEnvio(this.props.match.params.tipoRequerimento)) {
      // let options;
      // if (this.state.chaveConfirmacao) {
      //   options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
      // }
      const { requerimento } = { ...this.state };
      requerimento.tipoRequerimento = tipo;
      doPut(
        url,
        requerimento,
        this.trataSucessoResponseEnvio,
        this.trataErrosResponse,
      );
    } else {
      trataMensagensErro(['Informe corretamente os atributos indicados na tela.']);
    }
  }

  /**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */
  trataSucessoResponseEnvio = () => {
    this.trataSucesso();
    this.props.history.goBack();
  }

  trataSucesso = () => {
    const { requerimento } = { ...this.state };
    let mensagemSucesso = 'Requerimento Cessado.';
    const numeroDependentesCessando = this.verificaNumDepACessar(requerimento.dependentes);
    let todosDependentesCessados = false;
    let estaCessandoDependente = false;

    if (numeroDependentesCessando === requerimento.dependentes.length) {
      todosDependentesCessados = true;
    } else if (numeroDependentesCessando !== 0) {
      estaCessandoDependente = true;
      // ver quem esta cessando
    }
    if (todosDependentesCessados) {
      mensagemSucesso = 'Requerimento Cessado.';
    } else if (estaCessandoDependente) {
      mensagemSucesso = 'Dependente Cessado';
      if ((requerimento.dataCessacaoBeneficio !== null && requerimento.dataCessacaoBeneficio !== '') &&
      (requerimento.motivoCessacao !== null && requerimento.motivoCessacao !== '')) {
        mensagemSucesso = 'Requerimento Cessado.';
      }
    } else {
      mensagemSucesso = 'Requerimento Cessado.';
    }

    this.setState({
      showCessacaoBeneficioModal: !this.state.showCessacaoBeneficioModal,
    });
    trataMensagemSucesso([mensagemSucesso]);
  }

  trataErrosResponse = (error) => {
    if (error && error.data) {
      const { data } = { ...error };
      const { requerimento } = { ...this.state };
      const { validadeCampos } = { ...this.state };
      const touched = false;
      if (data.erros) {
        const colecaoErro = data.erros;
        colecaoErro.forEach((erro) => {
          if (erro.codigo === 1316 ||
            erro.codigo === 1334 ||
            erro.codigo === 1332 ||
            erro.codigo === 1432) {
            requerimento.dataCessacaoBeneficio = null;
            validadeCampos.dataCessacaoBeneficio = false;
          }
          if (requerimento.motivoCessacao === 0 ||
            requerimento.motivoCessacao === 22) {
            requerimento.motivoCessacao = null;
          }
        });
        validadeCampos.dependentes = false;
        const listaDependentes = this.state.requerimento.dependentes;
        if (listaDependentes) {
          const listaDependentesAtualizada = listaDependentes.map((item, i) => {
            const itemIndexado = item;
            itemIndexado.acoes = i;
            if (itemIndexado.cessando) {
              itemIndexado.foiCessado = false;
              itemIndexado.cessando = false;
              itemIndexado.dataCessacao = null;
            }
            return itemIndexado;
          });
          const totalDependentesACessar = undefined;
          requerimento.dependentes = listaDependentesAtualizada;
          this.setState({
            requerimento: {
              ...requerimento,
            },
            totalDependentesACessar,
            validadeCampos: {
              ...validadeCampos,
            },
          });
        }
      }
      this.setState({
        chaveConfirmacao: data.chaveConfirmacao,
        alertas: data.alertas,
        showModalAlerta: !this.state.showModalAlerta,
        touched,
      });
    }
  }

  formularioRequerimentoAposentadoria = () => (
    <DadosCessacaoAposentadoria
      acao={this.state.acao}
      auth={this.props.auth}
      estadoFormulario={this.state}
      handleChange={this.handleChange}
      match={this.props.match}
      motivosCessacaoRequerimento={this.props.motivosCessacaoRequerimentoAposentadoria}
    />
  );

  formularioRequerimentoPensao = () => (
    <DadosCessacaoPensao
      acao={this.state.acao}
      auth={this.props.auth}
      estadoFormulario={this.state}
      handleChange={this.handleChange}
      handleChangeDependentes={this.handleChangeDependentes}
      match={this.props.match}
      motivosCessacaoRequerimento={this.props.motivosCessacaoRequerimentoPensao}
      dependentes={this.state.requerimento.dependentes}
      addSemDepAtivosLabel={this.addSemDepAtivosLabel}
    />
  );

  handleFechamentoModalAlerta = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  render() {
    let modalAlerta;
    if (this.state.showModalAlerta) {
      const tipo = Number(this.props.match.params.tipoRequerimento);
      if (tipo === 1) {
        modalAlerta = (<ModalAlerta
          alertas={this.state.alertas}
          aceitar={this.confirmSendDataAposentadoria}
          handleModal={this.handleFechamentoModalAlerta}
          showModal
        />);
      } else {
        modalAlerta = (<ModalAlerta
          alertas={this.state.alertas}
          aceitar={this.confirmSendDataPensao}
          handleModal={this.handleFechamentoModalAlerta}
          showModal
        />);
      }
    }
    const botaoAcaoVoltar = (
      <Button
        className="left"
        onClick={this.props.history.goBack}
        title="Voltar"
        hint="Voltar para tela anterior"
      />
    );

    const botaoAcaoPrincipal = (
      <ProtectedItem allowedPermissions={['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rgps',
      'analisar-compensacao-rpps', 'analisar-negocio-sprev', 'gerenciar-negocio-dcomp']}
      >
        <Button
          className="dtp-primary right"
          disabled={!this.formularioProntoParaEnvio(this.props.match.params.tipoRequerimento)}
          title="Salvar"
          onClick={this.handleSaveButton}
          hint="Cessar requerimento"
        />
      </ProtectedItem>
    );

    const retorno = (
      <DtpContentContainer>
        {this.props.match.params.tipoRequerimento === '1' ? this.formularioRequerimentoAposentadoria() : this.formularioRequerimentoPensao()}
        <div className="row">
          { botaoAcaoVoltar }
          { botaoAcaoPrincipal }
        </div>
        {modalAlerta}
      </DtpContentContainer>
    );
    return retorno;
  }
}

RequerimentoCessacao.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      acao: PropTypes.string,
      tipoRequerimento: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    goBack: PropTypes.function,
  }).isRequired,
  motivosCessacaoRequerimentoAposentadoria: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  motivosCessacaoRequerimentoPensao: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
}.isRequired;

RequerimentoCessacao.defaultProps = {
  match: null,
  auth: null,
  motivosCessacaoRequerimentoAposentadoria: null,
  motivosCessacaoRequerimentoPensao: null,
};
const mapStateToProps = state =>
  ({
    motivosCessacaoRequerimentoAposentadoria: state.base.motivosCessacaoRequerimentoAposentadoria,
    motivosCessacaoRequerimentoPensao: state.base.motivosCessacaoRequerimentoPensao,
  });
export default connect(mapStateToProps)(RequerimentoCessacao);

// export default RequerimentoCessacao;




// WEBPACK FOOTER //
// ./src/pages/requerimentos/Cessacao/RequerimentoCessacao.jsx